import { render, staticRenderFns } from "./ModalRequiresId.vue?vue&type=template&id=0cc0e9cc&"
import script from "./ModalRequiresId.vue?vue&type=script&lang=js&"
export * from "./ModalRequiresId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports